import { Button, notification, Select, Input, Form, InputNumber } from "antd"
import Title from "antd/es/typography/Title"
import { GetLessonByID, UpdateLesson } from "../../../api/AdminService"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { ArrowLeftOutlined } from "@ant-design/icons"

const AdminDetailLesson = () => {
    const [form] = Form.useForm()
    const { id } = useParams();
    const [lesson, setLesson] = useState(null);
    const navigate = useNavigate()
    const GetLessonID = (id) => {
        GetLessonByID(id).then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setLesson(res.data)
                form.setFieldsValue({
                    title: res.data?.title,
                    content: res.data?.content,
                })
            }
        })
    }

    useEffect(() => {
        GetLessonID(id);
    }, [])

    const onFinish = (values) => {
        console.log('Received values of form:', values);
        UpdateLesson(id, values.title, values.content).then(res => {
            if (res.status === 201) {
                notification.success({
                    message: "Update Lesson Successfully"
                })
                GetLessonID(id);
            }
        }).catch(err => {
            notification.error({
                message: `${err.response.data.message}`
            })
        })
    }

    return (
        <div style={{ minHeight: '96.5vh', Width: '100%' }}>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                style={{ marginBottom: 16 }}
            >
                Go Back
            </Button>
            <div style={{ maxWidth: 400, margin: 'auto', padding: '24' }}>
                <Title level={2} style={{ textAlign: 'center', marginBottom: '24' }}>
                    Lesson
                </Title>
                <Form
                    onFinish={onFinish}
                    form={form}
                >
                    <Form.Item name={"title"} label="Lesson Title" rules={[{ required: true, message: 'Requiring Lesson Title' }]}>
                        <Input
                            placeholder="Input Lesson Title"
                        />
                    </Form.Item>
                    <Form.Item name={"content"} label="Content" rules={[{ required: true, message: 'Requiring Content' }]}>
                        <Input.TextArea
                            placeholder="Input Content"
                        />
                    </Form.Item>
                    <Form.Item >
                        <Button block type="primary" htmlType="submit">
                            Update Lesson
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>

    )
}

export default AdminDetailLesson